import type { Component } from 'vue';
import TextArea from '@utils/logicGate/statements/TextArea.vue';
import NumberRange from './NumberRange.vue';
import Boolean from './Boolean.vue';
import Choice from './Choice.vue';
import NullableChoice from './NullableChoice.vue';
import Enum from './Enum.vue';
import NullableEnum from './NullableEnum.vue';
import DateRange from './DateRange.vue';
import Search from './Search.vue';
import NumberComponent from './Number.vue';
import type { LogicStatementType } from '@/entities/Entities';

export { default as NumberRange } from './NumberRange.vue';

const mapping:{[K in LogicStatementType]: Component} = {
  numberRange: NumberRange,
  boolean: Boolean,
  nullableEnum: NullableEnum,
  enum: Enum,
  nullableChoice: NullableChoice,
  choice: Choice,
  dateRange: DateRange,
  search: Search,
  textArea: TextArea,
  number: NumberComponent,
};

export default mapping;
